<template>
    <FullFillBox
        :pageID="1014"
        @permissionData="(data) => {
            this.permissionDetails = data
            if(data.add === 1){
                this.showAddButton = true
            }
            if(data.edit === 1){
                this.showEditButton = true
            }
        }"
    >
        <h4>{{ $t('stock_take_main_table') }}</h4>
        <hr>
        <button class="btn btn-primary" style="width: 200px;"
                v-if="showAddButton"
                @click="addNewStockTakeMain">
            {{ $t('common_add') }}</button>
        <hr>
        <div ref="tabulatorTableUse"></div>
    </FullFillBox>

</template>

<script>
import FullFillBox from "@/components/routerViewLocation/FullFillBox";
import Multiselect from "@vueform/multiselect";
import {TabulatorFull as Tabulator} from "tabulator-tables";

export default {
    name: "StockTakeMainListView",
    components: {
        FullFillBox,
        Multiselect,
    },
    data(){
        return{
            permissionDetails: {},
            showAddButton: false,
            showEditButton: false,
            showAddNewPopUp: false,
            mainData: '',
            filterHide: true,
        }
    },
    methods: {
        updateStockTakeMain(row){
            let html = `<input id="swal-input" class="swal2-input" value="${row.getData().name}">`
            if(row.getData().flag === 1){
                html +=
                    `<select id="swal-select" class="swal2-select">
                        <option value="1" selected>${this.$t('common_show')}</option>
                        <option value="0" >${this.$t('common_hide')}</option>
                    </select>`
            }else{
                html +=
                    `<select id="swal-select" class="swal2-select">
                        <option value="1">${this.$t('common_show')}</option>
                        <option value="0" selected>${this.$t('common_hide')}</option>
                    </select>`
            }
            this.$swal.fire({
                title: this.$t('stock_take_main_create_add_name'),
                html: html,
                inputValidator: (inputValue) => {
                    return new Promise((resolve) => {
                        if (inputValue) {
                            resolve()
                        } else {
                            resolve(this.$t('stock_take_main_name_required'))
                        }
                    })
                },
                showCancelButton: true,
                confirmButtonText: this.$t('common_update'),
                showLoaderOnConfirm: true,
                preConfirm: () => {
                    return new Promise(async (resolve) => {
                        // Validate input
                        if (!document.getElementById('swal-input').value) {
                            resolve(this.$t('stock_take_main_name_required'))
                        } else {
                            this.$swal.resetValidationMessage(); // Reset the validation message.
                            await this.$mainApi.post('api/stock-take/stock-take-main/', {
                                "id": row.getData().id,
                                "name": document.getElementById('swal-input').value,
                                "flag": document.getElementById('swal-select').value,
                            })
                                .then(response => {
                                    resolve(response.data)
                                })
                                .catch(error => {
                                    this.$swal.showValidationMessage(
                                        `Request failed: ${error}`
                                    )
                                })
                        }
                    })
                },
                allowOutsideClick: () => !this.$swal.isLoading()
            }).then((result) => {
                if (result.isConfirmed) {
                    if(result.value.status === 80){
                        this.$swal.fire({
                            title: this.$t('common_success'),
                            icon: 'success'
                        })
                        this.getBackendData()
                    }else{
                        this.$swal.fire({
                            title: result.value.errors,
                            text: JSON.stringify(result.value.details),
                            icon: 'error'
                        })
                    }
                }
            })
        },
        addNewStockTakeMain(){
            this.$swal.fire({
                title: this.$t('stock_take_main_create_add_name'),
                input: 'text',
                inputValidator: (inputValue) => {
                    return new Promise((resolve) => {
                        if (inputValue) {
                            resolve()
                        } else {
                            resolve(this.$t('stock_take_main_name_required'))
                        }
                    })
                },
                inputAttributes: {
                    autocapitalize: 'off',
                },
                showCancelButton: true,
                confirmButtonText: this.$t('common_add'),
                showLoaderOnConfirm: true,
                preConfirm: (getName) => {
                    return this.$mainApi.post(`api/stock-take/stock-take-main/`, {
                        "name": getName,
                        "flag": 1,
                    })
                        .then(response => {
                            return response.data
                        })
                        .catch(error => {
                            this.$swal.showValidationMessage(
                                `Request failed: ${error}`
                            )
                        })
                },
                allowOutsideClick: () => !this.$swal.isLoading()
            }).then((result) => {
                if (result.isConfirmed) {
                    if(result.value.status === 80){
                        this.$swal.fire({
                            title: this.$t('common_success'),
                            icon: 'success'
                        })
                        this.getBackendData()
                    }else{
                        this.$swal.fire({
                            title: result.value.errors,
                            text: JSON.stringify(result.value.details),
                            icon: 'error'
                        })
                    }
                }
            })
        },
        async getBackendData(){
            await this.$mainApi.get('api/stock-take/stock-take-main/')
                .then(response => {
                    if(response.data.status === 80){
                        this.mainData = response.data.details
                        this.tabulator.setData(this.mainData.filter(a => a.flag !== 0))
                    }
                })
        }
    },
    mounted() {
        document.title = this.$t('title') + ' | ' + this.$t('stock_take_main_table')
        this.getBackendData()

        this.tabulator = new Tabulator(this.$refs.tabulatorTableUse, {
            placeholder: "<h3>" + this.$t('common_no_data') + "</h3>",
            data: [],
            columns: [
                {formatter: 'rownum', maxWidth: 20, responsive: 0},
                {
                    title: this.$t('table_name'), field: 'name', sorter: 'string', resizable: false,
                    responsive: 0, minWidth: 250, hozAlign: "center",
                    headerFilter: "input",
                    headerFilterParams: {
                        valuesLookup: true, sort: 'asc', clearable: true, autocomplete: true, listOnEmpty: true
                    },
                },
                {
                    title: 'Create Date', field: 'createTime', sorter: 'string', resizable: false,
                    responsive: 1, widthGrow: 2, hozAlign: "center",
                    headerFilter: "input",
                    headerFilterParams: {
                        valuesLookup: true, sort: 'asc', clearable: true, autocomplete: true, listOnEmpty: true
                    },
                },
                {
                    title: 'User', field: 'show_name', sorter: 'string', resizable: false,
                    responsive: 1, widthGrow: 1, hozAlign: "center",
                    headerFilter: "input",
                    headerFilterParams: {
                        valuesLookup: true, sort: 'asc', clearable: true, autocomplete: true, listOnEmpty: true
                    },
                },
                {
                    title: 'flag', field: 'flag', formatter: "tickCross", sorter: 'string', resizable: false,
                    responsive: 1, widthGrow: 1, hozAlign: "center",
                    headerFilter: "list",
                    headerFilterParams: {
                        valuesLookup: true, sort: 'asc', clearable: true, autocomplete: true, listOnEmpty: true
                    },
                },
                {
                    formatter: (cell) => {
                        return "<i class='bi bi-pencil-fill'></i>"
                    },
                    headerHozAlign: "center", hozAlign: "center", vertAlign: "middle", resizable: false,
                    headerMenu: this.getHeaderMenu,
                    headerSort: false, width: 10, responsive: 0,
                    cellClick:(e, row, formatterParams) => {
                        if(this.showEditButton){
                            this.updateStockTakeMain(row)
                        }else{
                            this.$toast.error(this.$t('error_no_permission'))
                        }
                    },
                    headerClick:(e, column) => {
                        if(this.filterHide === true){
                            // hide to show all
                            this.tabulator.setData(this.mainData)
                        }else{
                            // show all to hide
                            this.tabulator.setData(this.mainData.filter(a => a.flag !== 0))
                        }
                        this.filterHide = !this.filterHide
                    }
                },
                {
                    formatter: (cell) => {
                        return "<i class='bi bi-plus-circle-fill'></i>"
                    },
                    headerHozAlign: "center", hozAlign: "center", vertAlign: "middle", resizable: false,
                    headerMenu: this.getHeaderMenu,
                    headerSort: false, width: 10, responsive: 0,
                    cellClick:(e, row, formatterParams) => {
                        let stockTakeMainId = row.getData().id
                        this.$router.push(`/stock-take/details/${stockTakeMainId}`)
                    },
                    headerClick:(e, column) => {
                        if(this.filterHide === true){
                            // hide to show all
                            this.tabulator.setData(this.mainData)
                        }else{
                            // show all to hide
                            this.tabulator.setData(this.mainData.filter(a => a.flag !== 0))
                        }
                        this.filterHide = !this.filterHide
                    }
                },
            ],
            reactiveData: true, //enable data reactivity
            height: 'auto',
            responsiveLayout: 'collapse',
            layout: "fitColumns",
            movableColumns: true,
            movableRows: false,
        })
    }
}
</script>

<style scoped>

</style>
